import { render, staticRenderFns } from "./JugadoresComponente.vue?vue&type=template&id=e60c26b8&scoped=true"
import script from "./JugadoresComponente.vue?vue&type=script&lang=js"
export * from "./JugadoresComponente.vue?vue&type=script&lang=js"
import style0 from "./JugadoresComponente.vue?vue&type=style&index=0&id=e60c26b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60c26b8",
  null
  
)

export default component.exports